import { Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

interface InboxPillButtonProps {
  isInboxOpen: boolean;
  onInboxToggle: () => void;
}

export const InboxPillButton = ({
  isInboxOpen,
  onInboxToggle,
}: InboxPillButtonProps) => (
  <button
    type="button"
    onClick={onInboxToggle}
    aria-pressed={isInboxOpen}
    aria-label={isInboxOpen ? 'Close inbox' : 'Open inbox'}
    className={cn(
      'flex h-7 items-center justify-center gap-sm whitespace-nowrap rounded-full border-[0.5px] border-border-secondary px-md shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] outline-none transition-[background-color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:ring-2 focus-visible:ring-fg-tertiary',
      isInboxOpen ? 'bg-bg-tertiary' : 'bg-bg-primary'
    )}
  >
    <Icons.Inbox01
      className={cn(
        'size-4',
        isInboxOpen ? 'text-fg-brand' : 'text-fg-secondary'
      )}
    />
    <span
      className={cn(
        'txt-small-medium',
        isInboxOpen ? 'text-text-primary' : 'text-text-secondary'
      )}
    >
      Message
    </span>
  </button>
);
